const trial = {
  headers: [
    {
      text: 'Name',
      align: 'left',
      sortable: true,
      value: 'name',
      active: true,
    },
    {
      text: 'Created',
      align: 'left',
      sortable: true,
      value: 'date_created',
      active: true,
    },
    {
      text: 'Status',
      align: 'left',
      sortable: true,
      value: 'status',
      active: true,
    },
    {
      text: 'Fullname',
      align: 'left',
      sortable: true,
      value: 'fullname',
      active: true,
    },
    {
      text: 'Initiator',
      align: 'left',
      sortable: true,
      value: 'initiator',
      active: true,
    },
    {
      text: 'Brand',
      align: 'left',
      sortable: true,
      value: 'brand',
      active: true,
    },
    {
      text: 'Этапы процессов',
      align: 'left',
      sortable: true,
      value: 'processes',
      active: true,
    },
    {
      text: 'Количество процессов',
      align: 'left',
      sortable: true,
      value: 'planned_processes',
      active: true,
    },
    {
      text: 'Количество рецептур',
      align: 'left',
      sortable: true,
      value: 'planned_recipes',
      active: true,
    },
    {
      text: 'Planning date',
      align: 'left',
      sortable: true,
      value: 'planning_date_rng',
      active: true,
    },
    {
      text: 'Scheduled date',
      align: 'left',
      sortable: true,
      value: 'scheduled_date_rng',
      active: true,
    },
    {
      text: 'Plant',
      align: 'left',
      sortable: true,
      value: 'plant',
      active: true,
    },
    {
      text: 'Product',
      align: 'left',
      sortable: true,
      value: 'product',
      active: true,
    },
    {
      text: 'Итоговый выход продукта по трайлу',
      align: 'left',
      sortable: true,
      value: 'product_output',
      active: true,
    },
    {
      text: 'Project',
      align: 'left',
      sortable: true,
      value: 'project',
      active: true,
    },
    {
      text: 'Scale',
      align: 'left',
      sortable: true,
      value: 'scale',
      active: true,
    },
    {
      text: 'Your team',
      align: 'left',
      sortable: true,
      value: 'team',
      active: true,
    },
    {
      text: 'Technology',
      align: 'left',
      sortable: true,
      value: 'technology',
      active: true,
    },
    {
      text: 'Objectives',
      align: 'left',
      sortable: true,
      value: 'objectives',
      active: true,
    },
    {
      text: 'Trial sets',
      align: 'left',
      sortable: true,
      value: 'trialset_ids',
      active: true,
    },
  ],
  META: {
    PERMISSIONS: {
      EDIT: {
        color: 'warning',
      },
      DELETE: {
        color: 'error',
      },

      SHOWING_PROCESS_TAB: {
        value: 'SHOWING_PROCESS_TAB',
        color: 'warning',
      },
      SHOWING_RECIPE_TAB: {
        value: 'SHOWING_RECIPE_TAB',
        color: 'warning',
      },
      SHOWING_ANALYSIS_TAB: {
        value: 'SHOWING_ANALYSIS_TAB',
        color: 'warning',
      },
      SHOWING_MIXING_TAB: {
        value: 'SHOWING_MIXING_TAB',
        color: 'warning',
      },

      PROCESS_FILLING_RESULTS: {
        color: 'warning',
      },

      RECIPE_FILLING_RESULTS: {
        color: 'warning',
      },
      RECIPE_UPLOAD_FERMENTATION: {
        color: 'warning',
      },
      RECIPE_MODIFY_LOOSES: {
        color: 'warning',
      },
      RECIPE_MODIFY_INGREDIENTS_PARAM_VALUES: {
        color: 'warning',
      },
      RECIPE_MODIFY_VALUES: {
        color: 'warning',
      },

      MIXING_FILLING_RESULTS: {
        color: 'warning',
      },

      ANALYSIS_FILLING_RESULTS: {
        color: 'warning',
      },

      SAMPLING_FILLING_RESULTS: {
        color: 'warning',
      },
    },
    STATUS: {
      SEND_FOR_APPROVE: {
        color: 'success',
        cb: 'changeStatus',
      },
      BACK_TO_EDIT: {
        color: 'warning',
        cb: 'changeStatus',
      },
      DELEGATE_TO_LAB: {
        color: 'warning',
        cb: 'changeStatus',
      },
      BACK_TO_APPROVE: {
        color: 'warning',
        cb: 'changeStatus',
      },
      TAKE_TO_EXECUTING: {
        color: 'warning',
        cb: 'changeStatus',
      },
      TAKE_TO_ASSESSMENT: {
        color: 'warning',
        cb: 'changeStatus',
      },
      CHANGE_SAMPLING_EXECUTOR: {
        color: 'warning',
        cb: 'changeStatus',
      },
      REVOKE: {
        color: 'warning',
        cb: 'changeStatus',
      },
      APPROVE: {
        color: 'success',
        cb: 'changeStatus',
      },
      REJECT: {
        color: 'error',
        cb: 'changeStatus',
      },
      FINISH_WORKS_GLOBAL: {
        color: 'success',
        cb: 'changeStatus',
      },
      CLOSE_TRIAL: {
        color: 'success',
        cb: 'changeStatus',
      },

      TEAM_PO_FINISH_WORK: {
        color: 'success',
        cb: 'changeStatus',
      },
      TEAM_LAB_FINISH_WORK: {
        color: 'success',
        cb: 'changeStatus',
      },
      TEAM_MIX_FINISH_WORK: {
        color: 'success',
        cb: 'changeStatus',
      },
      TEAM_PO_CONTINUE_WORK: {
        color: 'warning',
        cb: 'changeStatus',
      },
      TEAM_LAB_CONTINUE_WORK: {
        color: 'warning',
        cb: 'changeStatus',
      },
      TEAM_MIX_CONTINUE_WORK: {
        color: 'warning',
        cb: 'changeStatus',
      },
    },
  },
  additionMetrics: [
    {
      text: 'Process',
      value: 'process',
      active: false,
    },
    {
      text: 'Stage',
      value: 'stage',
      active: false,
    },
    {
      text: 'Step',
      value: 'step',
      active: false,
    },
    {
      text: 'Parameter',
      value: 'parameter',
      active: false,
    },
    {
      text: 'Analysis type',
      value: 'analysis_type',
      active: false,
    },
    {
      text: 'Analysis',
      value: 'analysis',
      active: false,
    },
    {
      text: 'Subproduct',
      value: 'subproduct',
      active: false,
    },
    {
      text: 'Ingridient',
      value: 'ingridient',
      active: false,
    },
    {
      text: 'Package type',
      value: 'package_type',
      active: false,
    },
    {
      text: 'Количество WM по трайлу (кг)',
      value: 'wm_on_trial_kg',
      active: false,
    },
    {
      text: 'Количество MIX по трайлу (кг)',
      value: 'mix_on_trial_kg',
      active: false,
    },
    {
      text: 'Количество MIX по трайлу (шт)',
      value: 'mix_on_trial_count',
      active: false,
    },
    {
      text: 'Количество анализов internal',
      value: 'analyses_internal',
      active: false,
    },
    {
      text: 'Количество анализов external',
      value: 'analyses_external',
      active: false,
    },
    {
      text: 'Общее количество анализов',
      value: 'analyses_total',
      active: false,
    },
    {
      text: 'Цена анализов internal',
      value: 'analyses_cost_internal',
      active: false,
    },
    {
      text: 'Цена анализов external',
      value: 'analyses_cost_external',
      active: false,
    },
    {
      text: 'Общая цена анализов',
      value: 'analyses_cost_total',
      active: false,
    },
    {
      text: 'Количество отобранной упаковки в рамках трайла total (шт)',
      value: 'sampled_total',
      active: false,
    },
    {
      text: 'Количество отобранной упаковки в рамках трайла mixteam (шт)',
      value: 'sampled_by_mix',
      active: false,
    },
    {
      text: 'Количество отобранной упаковки в рамках трайла PO (шт)',
      value: 'sampled_by_po',
      active: false,
    },
    {
      text: 'Количество отобранных сущностей в рамках трайла (упаковка*объём)',
      value: 'sampled_elements',
      active: false,
    },
    {
      text: 'Оценка "работа лаборатории" (1-5)',
      value: 'assessment_laboratory_work',
      active: false,
    },
    {
      text: 'Оценка "работа mix team" (1-5)',
      value: 'assessment_mixteam_work',
      active: false,
    },
    {
      text: 'Оценка "работа оператора" (1-5)',
      value: 'assessment_operator_work',
      active: false,
    },
    {
      text: 'Оценка "cвоевременность отправки трайла" (1-5)',
      value: 'assessment_success_work',
      active: false,
    },
    {
      text: 'Оценка "корректность заполнения трайла" (1-5)',
      value: 'assessment_correct_filling',
      active: false,
    },
    {
      text: 'Оценка "коммуникация и доступность PM" (1-5)',
      value: 'assessment_communication_and_accessibility',
      active: false,
    },
    {
      text: 'Оценка "информирование персонала пилотного завода о работе с трайлом" (1-5)',
      value: 'assessment_informing_staff',
      active: false,
    },
  ]
};

const booking = {
  headers: [
    ...trial.headers.filter(header => {
      return header.value !== 'brand' && header.value !== 'trialset_ids' && header.value !== 'fullname'
    }),
  ],
  META: {
    PERMISSIONS: {
      BOOK_A_TRIAL: {
        color: 'warning',
      },
      EDIT: {
        color: 'warning',
      },
      DELETE: {
        color: 'error',
      },
      CONVERT_TO_TRIAL: {
        text: 'Convert to trial',
        color: 'success',
        to: 'convertToTrail',
      },
    },
    STATUS: {
      SEND_FOR_APPROVE: {
        color: 'success',
        cb: 'changeStatus',
      },
      BACK_TO_EDIT: {
        color: 'warning',
        cb: 'changeStatus',
      },
      APPROVE: {
        color: 'success',
        cb: 'changeStatus',
      },
      REJECT: {
        color: 'error',
        cb: 'changeStatus',
      },
    },
  },
};

export const CONST = {
  trial,
  booking,
  ITEM_STATUS: [
    {
      name: 'DONE',
      color: 'success',
    },
    {
      name: 'HOLD',
      color: 'warning',
    },
    {
      name: 'CANCELED',
      color: 'error',
    },
  ]
};

export const ROUND_UP = (target, precision) => {
  return Math.round(target * precision) / precision;
};

export const getUserFullName = (user) => {
  let fullname = `${user.first_name} ${user.last_name}`.trim();

  if (!fullname) {
    return user.username;
  }

  return `${fullname} (${user.username})`;
};

export const getDateTime = (dt) => {
  return `${dt.substr(0, 10)} ${dt.substr(11, 8)}`
};
